import { Row, Switch, Typography } from "@commonlibs";
import useTranslate from "ui/locale/hooks/useTranslate";
import useUserState from "ui/adapter/state/useUserState";
import { RoleType } from "common/models/role/Role";
import useSearchParam from "ui/common/hooks/useSearchParam";
import { useEffect } from "react";
import { GiftCardStockStatus } from "common/models/api/models/GiftCardStock";

export default function GiftCardsLeftToolbar() {
    const { selectedRole } = useUserState();
    const isCustomerService = selectedRole?.roleType === RoleType.CUSTOMER_SERVICE;
    const [type, setType] = useSearchParam("type");
    const [, setQuery] = useSearchParam("query");
    const giftCardType = type ?? GiftCardStockStatus.onDemand;
    const isActive = giftCardType === GiftCardStockStatus.onDemand ? true : false;
    const translate = useTranslate();

    const handleTypeChange = (toggleState: boolean): void => {
        if (toggleState) {
            setType(GiftCardStockStatus.onDemand);
        } else {
            setType(GiftCardStockStatus.stock);
        }
    };

    useEffect(() => {
        if (type === GiftCardStockStatus.stock) {
            setQuery("");
        }
    }, [type]);

    if (isCustomerService) {
        return null;
    }

    return (
        <Row justifyContent="start" alignItems={"center"} gap={10}>
            <Typography variant="body3Strong" color="primary.300" textAlign="center">
                {translate("voucherInventory")}
            </Typography>
            <Switch value={isActive} onChange={() => handleTypeChange(!isActive)} />
            <Typography variant="body3Strong" color="primary.300" textAlign="center">
                {translate("partner")}
            </Typography>
        </Row>
    );
}
